import { useLang } from "../contexts/LanguageContext";

// Tâche 1324, 2e passe (Eric 2026-06-30) — La bascule FR|EN vivait UNIQUEMENT
// dans l'en-tête du tableau de bord, donc derrière la connexion : les textes
// anglais de « Connexion » et « Créer un compte » existaient déjà mais rien ne
// permettait de les atteindre. Un anglophone voyait donc en français l'écran
// qui décide s'il entre ou non.
//
// `tone` existe parce que les deux écrans publics n'ont pas le même fond :
// bandeau bleu nuit sur la connexion, blanc cassé sur l'inscription. Du blanc
// sur blanc rendrait le bouton invisible, c'est-à-dire le bogue qu'on corrige.
export function PublicLangToggle({ tone = "dark", className = "" }) {
  const { lang, switchLang } = useLang();
  const surLombre = tone === "dark";
  const actif = surLombre ? "text-white" : "text-zinc-900";
  const inactif = surLombre ? "text-white/40" : "text-zinc-400";
  const separateur = surLombre ? "text-white/25" : "text-zinc-300";
  const survol = surLombre ? "hover:bg-white/10" : "hover:bg-zinc-200/70";

  return (
    <button
      type="button"
      onClick={() => switchLang(lang === "fr" ? "en" : "fr")}
      className={`h-8 px-2.5 flex items-center gap-1.5 rounded-lg text-xs font-semibold transition-colors ${survol} ${className}`}
      data-testid="public-lang-toggle-btn"
      aria-label={lang === "fr" ? "Passer en anglais" : "Switch to French"}
    >
      <span className={lang === "fr" ? actif : inactif}>FR</span>
      <span className={separateur}>|</span>
      <span className={lang === "en" ? actif : inactif}>EN</span>
    </button>
  );
}

export default PublicLangToggle;
